import { DatePicker, Select, Table, TableColumnsType } from 'antd';
import _ from 'lodash';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getPaymentRefunds } from '../../api/refunds.api';
import Button from '../../components/Button';
import DownloadButton from '../../components/DownloadButton';
import ErrorResponse from '../../components/ErrorResponse';
import SimpleHeader from '../../components/layout/SimpleHeader';
import Loader from '../../components/Loader';
import DatePickerTable from '../../components/statistics/DatePickerTable';
import RefundDetailModal from '../../components/payment/refund/modals/RefundDetailModal';
import ScrollView from '../../components/payment/ScrollView';
import SelectCampus from '../../components/SelectCampus';
import useAxios from '../../hooks/useAxios';
import useNotification from '../../hooks/useNotification';
import exportTable from '../../lib/exportTable';
import { getCommonCodeLabel } from '../../lib/store';
import { IGetPaymentRefunds, IPaymentRefund } from '../../models/refunds.model';
import { RootState } from '../../store/rootReducer';
import { DateTableType } from '../../constans';
import TableEmpty from '../../components/common/TableEmpty';

const PaymentRefund = () => {
  const { t } = useTranslation();
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetPaymentRefunds>();

  const [target, setTarget] = useState<string | undefined>();
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const [data, setData] = useState<any>([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [refundDetailVisible, setRefundDetailVisible] = useState(false);
  // 선택한 환불내역 PK
  const [refundNo, setRefundNo] = useState<number>();
  const [defSelType, setDefSelType] = useState<number>(2);

  useEffect(() => {
    if (serverDate) {
      const date = moment(serverDate).format('YYYYMMDD');
      setStartDate(date);
      setEndDate(date);
    }
  }, [serverDate]);

  useEffect(() => {
    if (res && !isLoading) {
      let total = 0;
      res.data.forEach((item: IPaymentRefund) => {
        total += item.refundAmount;
      });
      setTotalAmount(total);
      setData(res.data);
    }
  }, [res, isLoading]);

  const onSearch = () => {
    if (!startDate || !endDate) {
      return infoNotification(t('payment.charge.message1'));
    }

    execute(getPaymentRefunds({
      campusCode: currentCampus,
      paymentTargetCode: target,
      srtDate: startDate,
      endDate,
    }));
  };

  const onExportTable = () => {
    const _data = _.cloneDeep(data);
    _data.forEach((item: any) => {
      item.monthNameCode = getCommonCodeLabel('SY0009', item.monthNameCode?.trim() || '', 'ko');
      item.paymentTargetCode = getCommonCodeLabel('PA0001', item.paymentTargetCode, 'ko');
      item.calculateReasonCode = getCommonCodeLabel('PA0006', item.calculateReasonCode, 'ko');
      item.refundDttm = item.refundDttm ? moment(item.refundDttm).format('YYYY.MM.DD HH:mm') : '';
      item.paymentAmount = item.paymentAmount;
      item.refundAmount = item.refundAmount;
    });
    const currentDate = moment(new Date());
    exportTable(columns, _data, `${t('payment.refund.1')}_(${currentDate.format('YYYYMMDD')})`, t('payment.refund.1'), [15, 10, 20, 15, 10, 20, 15, 15, 10, 20]);
  }

  const columns: TableColumnsType<IPaymentRefund> = [
    {
      title: '#',
      dataIndex: 'paymentRecordCode',
      key: 'paymentRecordCode',
      align: 'center',
    },
    {
      title: t('common.column.semester'),
      dataIndex: 'semesterName',
      key: 'semesterName',
      align: 'center',
    },
    {
      title: t('payment.charge.column1'),
      dataIndex: 'monthNameCode',
      key: 'monthNameCode',
      align: 'center',
      render: (value: string) =>
        getCommonCodeLabel('SY0009', value?.trim() || '', 'ko'),
    },
    {
      title: t('common.menu.class'),
      dataIndex: 'className',
      key: 'className',
      align: 'center',
    },
    {
      title: t('payment.refund.column1'),
      dataIndex: 'paymentTargetCode',
      key: 'paymentTargetCode',
      align: 'center',
      render: (value: string) => getCommonCodeLabel('PA0001', value, 'ko'),
    },
    {
      title: t("payment.coupon.placeholder2"),
      dataIndex: 'memberName',
      key: 'memberName',
      align: 'center',
      render: (value, record) => (
        <span
          className="pointer"
          onClick={() => {
            setRefundNo(record.refundNo);
            setRefundDetailVisible(true);
          }}
        >
          <u>{value}</u>
        </span>
      ),
    },
    {
      title: t('payment.charge.column4'),
      dataIndex: 'memberCode',
      key: 'memberCode',
      align: 'center',
    },
    {
      title: t('payment.record.column3'),
      dataIndex: 'paymentAmount',
      key: 'paymentAmount',
      align: 'center',
      render: (value: number) => value?.toLocaleString(),
    },
    {
      title: t('payment.refund.column2'),
      dataIndex: 'refundAmount',
      key: 'refundAmount',
      align: 'center',
      render: (value: number) => value?.toLocaleString(),
    },
    {
      title: t('payment.refund.column3'),
      dataIndex: 'calculateReasonCode',
      key: 'calculateReasonCode',
      align: 'center',
      render: (value: string) => getCommonCodeLabel('PA0006', value, 'ko'),
    },
    {
      title: t('payment.refund.column4'),
      dataIndex: 'refundDttm',
      key: 'refundDttm',
      align: 'center',
      render: (value: string) => moment(value).format('YYYY.MM.DD HH:mm'),
    },
  ];

  console.log(res);

  return (
    <>
    <div className="common-search">
      <div className="search-area">
        <ul className="search-bx">
          <li>
            <label>{t('common.menu.campus')}</label>
            <div>
              <SelectCampus />
            </div>
          </li>
          <li>
            <label>{t('payment.charge.column3')}</label>
            <div>
              <Select
                placeholder={t('payment.charge.column3')}
                value={target}
                onChange={(value) => setTarget(value)}
              >
                <Select.Option value="">{t('common.text.all')}</Select.Option>
                <Select.Option value="PT">{t('payment.charge.option1')}</Select.Option>
                <Select.Option value="TU">{t('payment.charge.option2')}</Select.Option>
                <Select.Option value="ON">{t('payment.charge.option3')}</Select.Option>
                <Select.Option value="AL">{t('payment.charge.option4')}</Select.Option>
                <Select.Option value="ST">{t('payment.charge.option5')}</Select.Option>
                <Select.Option value="SC">{t('payment.charge.option6')}</Select.Option>
                <Select.Option value="ET">기타</Select.Option>
              </Select>
            </div>
          </li>
          <li className="period">
            <label>{t('sms.list.column1')}</label>
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center">  
                <div className="date-picker__area">
                  <DatePicker
                    value={startDate ? moment(startDate) : undefined}
                    onChange={(e) => {
                      if (e === null) setStartDate('');
                      else setStartDate(moment(e).format('YYYYMMDD'));
                    }}
                  />
                  ~
                  <DatePicker
                    value={endDate ? moment(endDate) : undefined}
                    onChange={(e) => {
                      if (e === null) setEndDate('');
                      else setEndDate(moment(e).format('YYYYMMDD'));
                    }}
                  />
                </div>
                <div className="comm-btn__area">
                  <Button
                    className="btn-basic small black"
                    onClick={onSearch}
                    text={t('common.button.search')}
                  />
                </div>
              </div>
              <div className="comm-btn__area  mt-2">
                <DatePickerTable
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  type={DateTableType.ALL}
                  defSelType={defSelType}
                  setDefSelType={setDefSelType}
                />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>    
    <div className="content scrollbar">
      {isLoading && <Loader />}
      <ErrorResponse error={error} />
      <SimpleHeader
        iconFile="icon-payment-big.svg"
        parentMenu={t('common.menu.payment')}
        currentMenu={t('payment.refund.title1')}
        onlyTitle={true}
      />

      <div className="col-frame">
        {data.length > 0 ? (
          <>
            <div className="comm-bx__between">
              <div className="comm-sch_result">
                {t('payment.refund.text1')}: <b>{totalAmount.toLocaleString()}</b>{t('payment.charge.text2')}
              </div>
            </div>
            <div className="comm-table__area">
              <Table
                columns={columns}
                dataSource={data}
                pagination={{
                  pageSize: 9999999,
                }}
              />
            </div>
            <div className="comm-bx__between">
              <div className="comm-btn__area">
                <DownloadButton onClick={onExportTable} />
              </div>
            </div>
          </>
          ) : (
          <TableEmpty text={t('payment.refund.text2')} />
        )}
      </div>

      {refundDetailVisible &&
        <RefundDetailModal
          visible={refundDetailVisible}
          setVisible={setRefundDetailVisible}
          refundNo={refundNo}
        />
      }
    </div>
    </>
  );
};

export default PaymentRefund;
